import { apiClient } from './client';
import type { AwardBookingDto, Booking, BookingLineItem, SignBookingDto } from '@/types/booking.types';

class BookingService {
  async listBookings(celebrationId: number): Promise<Booking[]> {
    const response = await apiClient.get(`/celebrations/${celebrationId}/bookings`);
    return response.data.data || [];
  }

  async getBooking(celebrationId: number, bookingId: number): Promise<Booking> {
    const response = await apiClient.get(`/celebrations/${celebrationId}/bookings/${bookingId}`);
    return response.data.data;
  }

  async transitionStatus(celebrationId: number, bookingId: number, status: string): Promise<Booking> {
    const response = await apiClient.patch(
      `/celebrations/${celebrationId}/bookings/${bookingId}/status`,
      { status }
    );
    return response.data.data;
  }

  async awardBooking(celebrationId: number, bookingId: number, payload?: AwardBookingDto): Promise<Booking> {
    const response = await apiClient.patch(
      `/celebrations/${celebrationId}/bookings/${bookingId}/award`,
      payload || {}
    );
    return response.data.data;
  }

  async signBooking(celebrationId: number, bookingId: number, payload?: SignBookingDto): Promise<Booking> {
    const response = await apiClient.patch(
      `/celebrations/${celebrationId}/bookings/${bookingId}/signing`,
      payload || {}
    );
    return response.data.data;
  }

  async listLineItems(celebrationId: number, bookingId: number): Promise<BookingLineItem[]> {
    const response = await apiClient.get(
      `/celebrations/${celebrationId}/bookings/${bookingId}/line-items`
    );
    return response.data.data || [];
  }

  async transitionLineItemStatus(
    celebrationId: number,
    bookingId: number,
    lineItemId: number,
    status: string
  ): Promise<BookingLineItem> {
    const response = await apiClient.patch(
      `/celebrations/${celebrationId}/bookings/${bookingId}/line-items/${lineItemId}/status`,
      { status }
    );
    return response.data.data;
  }
}

export const bookingService = new BookingService();
